import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_SALE_REGISTER } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

function SalesCreditNoteRegisterListActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const { salesInvoiceRegister } = useTranslatedMessages();
  const canCreate = hasEInvoicePermission(CREATE_SALE_REGISTER);

  const handleCreateAction = () => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    navigate('/sales-invoice-register/credit-notes/create');
  };

  return (
    <>
      <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
        <Button
          id="create-sales-credit-note-register"
          variant="contained"
          color="primary"
          onClick={handleCreateAction}
          disabled={!canCreate}
        >
          {salesInvoiceRegister?.list_actions?.create_credit_note_entry ?? '+ Add Entry'}
        </Button>
      </PermissionDeniedWrapper>
      <SubscriptionModal />
    </>
  );
}

export default SalesCreditNoteRegisterListActions;
